<script lang="ts">
	// What a catalogue page shows when it cannot be drawn: the API did not
	// answer, or Cloudflare served a static file because the day's allowance of
	// worker requests is spent. Drawn by the worker with a 503, or in the
	// browser over the static file.

	import Button from '../components/Button.svelte';
	import Card from '../components/Card.svelte';
	import { down } from './copy';
	import Shell from './Shell.svelte';

	interface Props {
		ownersHref: string;
		/** This page's own address, to ask for it again. */
		retryHref: string;
	}

	let { ownersHref, retryHref }: Props = $props();
</script>

<svelte:head>
	<title>{down.pageTitle}</title>
	<meta name="robots" content="noindex" />
</svelte:head>

<Shell page="down" {ownersHref}>
	<div class="center">
		<div class="card">
			<Card pad testId="catalogue-down">
				<div class="body">
					<h1>{down.title}</h1>
					<p class="copy">{down.body}</p>
					<Button
						testId="catalogue-retry"
						tone="secondary"
						size="md"
						label={down.retry}
						href={retryHref}
					/>
				</div>
			</Card>
		</div>
	</div>
</Shell>

<style>
	.center {
		flex: 1;
		display: grid;
		place-items: center;
	}

	.card {
		inline-size: 100%;
		max-inline-size: 440px;
	}

	.body {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: var(--space-7);
	}

	h1 {
		margin: 0;
		font-size: var(--text-h3);
		font-weight: var(--weight-bold);
		letter-spacing: var(--tracking-tight);
		line-height: var(--leading-headline);
		text-wrap: pretty;
	}

	.copy {
		margin: 0;
		font-size: var(--text-base);
		line-height: var(--leading-snug);
		color: var(--text-body);
	}
</style>
